import { RequestNote } from "../../types/RequestNote";
import api from "./api";

const requestNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRequestNotes: build.query<
      RequestNote[],
      { requestId: string; noteType?: string; medicalRequestId?: string }
    >({
      query: ({ requestId, noteType, medicalRequestId }) => {
        const params = new URLSearchParams();
        if (noteType) params.set("noteType", noteType);
        if (medicalRequestId) params.set("medicalRequestId", medicalRequestId);
        const qs = params.toString();
        return `/requests/${requestId}/notes${qs ? `?${qs}` : ""}`;
      },
      providesTags: (
        result,
        error,
        { requestId, noteType, medicalRequestId }
      ) => [
        {
          type: "RequestNotes",
          id: `${requestId}-${noteType || "all"}-${medicalRequestId || "top"}`,
        },
      ],
    }),
    createRequestNote: build.mutation<
      RequestNote,
      {
        requestId: string;
        noteType: string;
        body: string;
        medicalRequestId?: string;
      }
    >({
      query: ({ requestId, ...body }) => ({
        url: `/requests/${requestId}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { requestId }) => [
        { type: "RequestNotes", id: `${requestId}-client-top` },
        { type: "RequestNotes", id: `${requestId}-internal-top` },
        { type: "RequestNotes", id: `${requestId}-all-top` },
        // Also invalidate all medical request note caches for this request
        { type: "RequestNotes" },
      ],
    }),
    updateRequestNote: build.mutation<
      RequestNote,
      {
        requestId: string;
        noteId: string;
        body?: string;
        isHighlighted?: boolean;
        isBanned?: boolean;
      }
    >({
      query: ({ requestId, noteId, ...fields }) => ({
        url: `/requests/${requestId}/notes/${noteId}`,
        method: "PATCH",
        body: fields,
      }),
      invalidatesTags: (result, error, { requestId }) => [
        { type: "RequestNotes" },
      ],
    }),
    deleteRequestNote: build.mutation<
      { status: string },
      { requestId: string; noteId: string }
    >({
      query: ({ requestId, noteId }) => ({
        url: `/requests/${requestId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { requestId }) => [
        { type: "RequestNotes" },
      ],
    }),
  }),
});

export const {
  useGetRequestNotesQuery,
  useCreateRequestNoteMutation,
  useUpdateRequestNoteMutation,
  useDeleteRequestNoteMutation,
} = requestNotesApi;
